/* eslint-disable no-unused-vars */

// import { store } from 'redux/store';

import { getDataPoints } from '@pages/settings/helper';
import { cleanString } from '@utilities/attachments';

export const searchPipelineData = ({ pipeline = {}, inputValue = '', store }) => {
  const { settings, picklists, cache } = store;
  const { picklistsMap, areaHierarchyTreeDataMap = {} } = picklists;
  const { sitesMap = {}, sites: cacheSites = [] } = cache;
  const { siteDisplayFields } = settings.settings;
  const siteHiddenDisplayFields = settings.hiddenDataPointsForAssets?.site || '';

  const {
    siteIds,
    licenseNumber,
    lineNumber,
    dataPoints,
    toLocation,
    fromLocation,
    dataPointsForSearch
  } = pipeline;
  const sites = siteIds?.map((x) => cacheSites[sitesMap[x]] || {});

  const sitesTitle =
    sites
      ?.map((x) =>
        x?.parent
          ? 'View all work at'
          : areaHierarchyTreeDataMap[x?.areaHierarchy || '']?.title || ''
      )
      .reduce((acc, name, index) => {
        acc[`siteTitle${index}`] = name;
        return acc;
      }, {}) || [];
  const siteName =
    sites
      ?.map((x) => {
        return x.name;
      })
      ?.reduce((acc, name, index) => {
        acc[`siteName${index}`] = name;
        return acc;
      }, {}) || [];

  const title = `${licenseNumber} - ${lineNumber}`;
  const title1 = `${licenseNumber}-${lineNumber}`;

  const pipelineDataPointsCombine = [...(dataPointsForSearch || []), ...(dataPoints || [])];

  const dataPointsObject = pipelineDataPointsCombine.reduce(
    (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
    {}
  );

  const dataPointsForSite = sites.flatMap((x) => {
    const dataPointsForSite = siteDisplayFields
      ? pipeline?.dataPointsForSite[x.siteId]
        ? pipeline?.dataPointsForSite[x.siteId]
        : getDataPoints({ ...x, type: x.siteType }, siteDisplayFields, 'site', picklistsMap)
      : [];

    const siteDataPointsForSearch = siteHiddenDisplayFields
      ? pipeline?.siteDataPointsForSearch[x.siteId]
        ? pipeline?.siteDataPointsForSearch[x.siteId]
        : getDataPoints({ ...x, type: x?.siteType }, siteHiddenDisplayFields, 'site', picklistsMap)
      : [];

    const siteDataPointsCombine = [
      ...(siteDataPointsForSearch || []),
      ...(dataPointsForSite || [])
    ];

    return siteDataPointsCombine;
  });

  const dataPointsObjectFOrSite = dataPointsForSite.reduce((acc, item, index) => {
    acc[`${[item.key]}${index}`] = `${item.title} : ${item.value}`;
    return acc;
  }, {});

  const filterObject = {
    title,
    title1,
    toLocation,
    fromLocation,
    ...sitesTitle,
    ...siteName,
    ...dataPointsObject,
    ...dataPointsObjectFOrSite
  };

  const cleanInput = cleanString(inputValue);

  if (
    !Object.values(filterObject).some((value) => {
      return cleanString(String(value)).includes(cleanInput);
    })
  )
    return false;

  return true;
};
